import React, { useEffect, useState, useRef } from "react";
import SideBar from "./Sidebar";
import AdminSideBar from "./Adminsidebar";
import { connect } from "react-redux";
import axios from "../axios";
import ClipLoader from "react-spinners/ClipLoader";

import Slider from "@mui/material/Slider";
import { CustomSlider } from "./Common/CustomSlider";
import AdminNavbar from "./Adminsidebar";
import Topbar from "./Topbar";

// import { Slider, RangeSlider } from 'rsuite';
// import 'rsuite/dist/rsuite.min.css';
const AdminSettings = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getfetchConfigurations();
    //Runs only on the first render
  }, []);

const [responsed,setResponsed] = useState("");

  const getfetchConfigurations = async () => {
    await axios
      .get(`/configurationData/${localStorage.doctorId}`, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        if(response.status == 200){
       setResponsed(response)
        }
      });
  };
  if(responsed == ""){
    return (
      <div className="loadingdiv">
      <ClipLoader color={"#fd8c00"} size={30} />
    </div>
    )
  }else
  return (
    
    <AdminSettingsChild response={responsed}  />
  )
}

const AdminSettingsChild = (props) => {
  console.log(props);
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 1000;
  console.log();
  const [risk, setRisk] = useState("risk_s" in props.response.data.configuration ? props.response.data.configuration.risk_s : 1);
  const [tb, setTb] = useState("tb_s" in props.response.data.configuration ? props.response.data.configuration.tb_s : 1);
  const [pattern, setPattern] = useState("pattern_s" in props.response.data.configuration ? props.response.data.configuration.pattern_s : 2);
  const [covid, setCovid] = useState("covid_s" in props.response.data.configuration ? props.response.data.configuration.covid_s : 2);
  const initialRender = useRef(true);

  const handleRiskButton = (add, minus) => {
    if (add == true) {
      if (risk != 2) {
        setRisk(risk + 1);
      }
    }
    if (minus == true) {
      if (risk != 0) {
        setRisk(risk - 1);
      }
    }
  };
  const handleTbButton = (add, minus) => {
    if (add == true) {
      if (tb != 2) {
        setTb(tb + 1);
      }
    }
    if (minus == true) {
      if (tb != 0) {
        setTb(tb - 1);
      }
    }
  };
  const handlePatternButton = (add, minus) => {
    if (add == true) {
      if (pattern != 2) {
        setPattern(pattern + 1);
      }
    }
    if (minus == true) {
      if (pattern != 0) {
        setPattern(pattern - 1);
      }
    }
  };
  const handleCovidButton = (add, minus) => {
    if (add == true) {
      if (covid != 2) {
        setCovid(covid + 1);
      }
    }
    if (minus == true) {
      if (covid != 0) {
        setCovid(covid - 1);
      }
    }
  };
  const handleRiskChange = (event) => {
    console.log(risk);
    setRisk(event.target.value);
  };
  const handleTbChange = (event) => {
    setTb(event.target.value);
  };
  const handlePatternChange = (event) => {
    setPattern(event.target.value);
  };
  const handleCovidChange = (event) => {
    setCovid(event.target.value);
  };

 

  

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      console.log(risk);
      postfetchConfigurations();
    }
  }, [risk,pattern,tb,covid]);


  const postfetchConfigurations = async () => {
    var jsonData = {
      risk_s: risk,

      pattern_s: pattern,

      covid_s: covid,

      tb_s: tb,
    };
    await axios
      .post(`/adminConfig`, jsonData, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {});
  };
  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
  return (
    <div className="dashboard">
      {/* <AdminNavbar AdminSettings /> */}
      {/* <AdminSideBar AdminSettings /> */}

      {/* {width < breakpoint ? (
        <div className="mobiletitle" style={{ paddingLeft: "2rem" }}>
          Swaasa
        </div>
      ) : (
        <div></div>
      )} */}
      <Topbar />

      <div className="dashboard__content" style={{padding: '3rem', overflow: 'visible'}}>
        <CustomSlider
          prefix="Risk"
          heading="Sensitivity"
          value={risk}
          handleChange={handleRiskChange}
          handleButton={handleRiskButton}
        />
        <CustomSlider
          prefix="Pattern"
          heading="Sensitivity"
          value={pattern}
          handleChange={handlePatternChange}
          handleButton={handlePatternButton}
        />
        <CustomSlider
          prefix="Covid"
          heading="Sensitivity"
          value={covid}
          handleChange={handleCovidChange}
          handleButton={handleCovidButton}
        />
        <CustomSlider
          prefix="TB"
          heading="Sensitivity"
          value={tb}
          handleChange={handleTbChange}
          handleButton={handleTbButton}
        />
      </div>
    </div>
  );
};

export default AdminSettings;
